module.exports = __webpack_public_path__ + "static/media/MediaHub.65f6dcce.png";